import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const AlertPopup = ({ title, message, handleOk }) => {
  const { t } = useTranslation();

  return (
    <div className="custom-alert-pop common_alert_popup">
      <div className="custom-alert-container">
        <div className="custom-alert-wrap">
          <div className="custom-alert-header">
            <h4>{title}</h4>
          </div>
          <div className="custom-alert-body">
            <p>{message}</p>
            <div className="alert-buttons">
              <button title={t("ok_txt")} onClick={handleOk} className="popup-alert-btn button">
                {t("ok_txt")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertPopup;
